declare global {
  interface Window {
    aa?: (method: string, ...args: unknown[]) => void
  }
}

export const trackSearchView = (
  indexName: string,
  objectIDs: string[],
  queryID?: string
): void => {
  if (typeof window === 'undefined' || !window.aa) return

  window.aa('viewedObjectIDs', {
    index: indexName,
    objectIDs,
    eventName: 'Search Results Viewed',
    ...(queryID && { queryID }),
  })
}

export const trackSearchClick = (
  indexName: string,
  objectID: string,
  position: number,
  queryID?: string
): void => {
  if (!queryID || typeof window === 'undefined' || !window.aa) return

  window.aa('clickedObjectIDsAfterSearch', {
    index: indexName,
    objectIDs: [objectID],
    positions: [position],
    eventName: 'Search Result Clicked',
    queryID,
  })
}
